import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import useAtmosphere from '../hooks/useAtmosphere'


import RemoveAtlassianAuthMutation from '../mutations/RemoveAtlassianAuthMutation'
import AtlassianClientManager from '../utils/AtlassianClientManager'
import Menu from './Menu'
import MenuItem from './MenuItem'







const AtlassianConfigMenu = (props) => {
  const {menuProps, mutationProps, teamId} = props
  const {onError, onCompleted, submitMutation, submitting} = mutationProps
  const atmosphere = useAtmosphere()
  const openOAuth = () => {
    AtlassianClientManager.openOAuth(atmosphere, teamId, mutationProps)
  }

  const removeAtlassian = () => {
    if (submitting) return
    submitMutation()
    RemoveAtlassianAuthMutation(atmosphere, {teamId}, {onError, onCompleted})
  }
  return (
    _jsxs(Menu, { ariaLabel: 'Configure your Atlassian integration', ...menuProps, children: [
      _jsx(MenuItem, { label: "Refresh token" , onClick: openOAuth,} )
      , _jsx(MenuItem, { label: "Remove Atlassian" , onClick: removeAtlassian,} )
    ]})
  )
}

export default AtlassianConfigMenu
